import { createSelector } from "@reduxjs/toolkit";
import { StoreState } from "../../store";

const selector = (state: StoreState) => state.history;

export const historySelectors = {
  totalHistories: createSelector(selector, (state) => state.totalHistories),
  histories: createSelector(selector, (state) => state.histories),
};
